var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.name))])],1),_c('v-list-item-action',[_c('v-btn',{attrs:{"loading":_vm.loading,"color":"secondary"},on:{"click":_vm.confirmUpgrade}},[_vm._v("Upgrade")])],1)],1),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }